export default {
  // 1-3
  employeeDetail: {},
  attachment: "",
};
